module.exports = __webpack_public_path__ + "img/Upcloud.11e1881f.png";